import React, { useState } from "react";
import styles from "../../assets/scss/HelpCenterNormalUser/HelpCenterUserView.module.scss";
import Pagination from "../../Components/Common/Pagination";
import { useNavigate, useLocation } from "react-router-dom";
import { useGetEnquiryResponsesQuery } from "../../slices/admin/admin";

const HelpCenterUserView = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const enquiryId = location.state?.enquiryId;

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);

  /* ✅ API CALL */
  const { data, isLoading } = useGetEnquiryResponsesQuery(
    {
      enquiryId,
      offset: currentPage,
      limit,
    },
    {
      skip: !enquiryId,
    }
  );
  const tableDataHead = data;
  const tableData = data?.data || [];
  const totalCount = data?.total || 0;
  const totalPages = Math.ceil(totalCount / limit);

  return (
    <div className={styles.billingContainer}>
      {/* HEADER */}
      <div className={styles.header}>
        <h2 className={styles.tittle}>Help Center Responses</h2>
        <span
          className={styles.closeIcon}
          onClick={() => navigate("/dashboard/HelpCenter")}
        >
          ✕
        </span>
      </div>

      {/* TABLE */}
      <div className={styles.billingContainers}>

        <div className={styles.itemsSection}>
          <div className={styles.itemsHeader}>
            <h4>{tableDataHead?.comments} - {tableDataHead?.queries}</h4>


          </div>
          <div className={styles.tableWrapper}>
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>User Name</th>
                  <th>Comments</th>
                  <th>Mode of Contact</th>
                  <th>Status</th>
                  <th>Created At</th>
                </tr>
              </thead>

              <tbody>
                {isLoading && (
                  <tr>
                    <td colSpan={6} className={styles.noData}>
                      Loading...
                    </td>
                  </tr>
                )}

                {!isLoading && tableData.length === 0 && (
                  <tr>
                    <td colSpan={6} className={styles.noData}>
                      No records found
                    </td>
                  </tr>
                )}

                {!isLoading &&
                  tableData.map((item, index) => (
                    <tr key={item._id}>
                      <td>
                        {(currentPage - 1) * limit + index + 1}
                      </td>

                      <td>
                        {item.createdBy?.firstName}{" "}
                        {item.createdBy?.lastName}
                      </td>

                      <td>{item.comments}</td>
                      <td>{item.modeOfContact || "-"}</td>

                      <td
                       
                      >
                        <span
  className={
    item.status === "completed"
      ? styles.statusCompleted
      : item.status === "inprogress"
      ? styles.statusInProgress
      : styles.statusPending
  }
>
  {item.status}
</span>
                      </td>

                      <td>
                        {new Date(item.createdAt).toLocaleString("en-IN")}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* PAGINATION */}
        <div className={styles.paginationWrapper}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />

          <select
            className={styles.inputsbtn}
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10 rows</option>
            <option value={25}>25 rows</option>
            <option value={50}>50 rows</option>
          </select>
        </div>

        {/* FOOTER */}
        <div className={styles.footerButtons}>
          <button
            className={styles.cancelBtn}
            onClick={() => navigate("/dashboard/HelpCenter")}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default HelpCenterUserView;

